import { createContext, type ReactNode,useContext } from "react";

import useScimWizard from "../hooks/useScimWizard";

type ScimWizardContextValue = ReturnType<typeof useScimWizard>;

const ScimWizardContext = createContext<ScimWizardContextValue | null>(null);

export const useScimWizardContext = (): ScimWizardContextValue => {
	const context = useContext(ScimWizardContext);
	if (!context) {
		throw new Error("useScimWizardContext must be used within a ScimWizardProvider");
	}
	return context;
};

type ScimWizardProviderProps = {
	children: ReactNode;
	editedId?: string | number | null;
};

export const ScimWizardProvider = ({ children, editedId: _editedId }: ScimWizardProviderProps) => {
	const scimWizard = useScimWizard();
	return (
		<ScimWizardContext.Provider value={scimWizard}>
			{children}
		</ScimWizardContext.Provider>
	);
};
